import { ChangeEventHandler, forwardRef, useEffect, useState } from 'react';

import { $generateHtmlFromNodes } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useTranslation } from 'react-i18next';

import { RichTextEditorHTMLTextarea } from '../RichTextEditor.styles';

interface HTMLEditModePluginProps {
  id: string;
}

const HTMLEditModePlugin = forwardRef<
  HTMLTextAreaElement,
  HTMLEditModePluginProps
>(({ id }, ref) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();
  const [content, setContent] = useState('');

  useEffect(() => {
    editor.update(() => {
      const htmlContent = $generateHtmlFromNodes(editor);
      setContent(htmlContent);
    });
  }, []);

  const handleOnChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    setContent(event.target.value);
  };

  return (
    <RichTextEditorHTMLTextarea
      aria-label={t('form.editor.buttons.editHTMLTextarea')}
      data-testid={`${id}-textarea`}
      value={content}
      onChange={handleOnChange}
      rows={10}
      ref={ref}
    />
  );
});

export default HTMLEditModePlugin;
